module.exports = __webpack_public_path__ + "img/post-blog-cortado.2d416162.png";